/**
 * Identify a given action.
 *
 * If the passed action is actually a function (e.g. when using the `thunk`
 * middleware) this creates a hased representation of the function body. If it
 * is a standard flux action with a type property, the type is returned.
 */
'use strict';

exports.__esModule = true;

exports['default'] = function (action) {
  if (typeof action !== 'function') {
    return action.type;
  }

  var hash = 0;
  var string = action.toString();
  for (var _iterator = string, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var index = _ref;

    var value = (hash << 5) - hash + string.charCodeAt(index);
    hash = value & value;
  }

  return Math.abs(hash);
};

module.exports = exports['default'];